import { useState } from 'react';
import { db } from '../firebase';
import { doc, updateDoc, deleteDoc } from 'firebase/firestore';

const SERVICES = ['Branding & Identity','Digital Marketing','Website & Digital','Media Production','Event Management','Graphic Design'];

export default function AdminReservations({ reservations, setReservations }) {
  const [editing, setEditing] = useState(null);

  const save = async () => {
    const { id, createdAt, ...data } = editing;
    await updateDoc(doc(db, 'reservations', id), data);
    setReservations(p => p.map(r => r.id === id ? editing : r));
    setEditing(null);
  };

  const updateStatus = async (id, status) => {
    await updateDoc(doc(db, 'reservations', id), { status });
    setReservations(p => p.map(r => r.id === id ? { ...r, status } : r));
  };

  const remove = async id => {
    if (!window.confirm('Delete this reservation?')) return;
    await deleteDoc(doc(db, 'reservations', id));
    setReservations(p => p.filter(r => r.id !== id));
  };

  const field = (key, label, type = 'text') => (
    <div className="edit-field">
      <label>{label}</label>
      {type === 'select' ? (
        <select value={editing[key] || ''} onChange={e => setEditing(p => ({ ...p, [key]: e.target.value }))}>
          {SERVICES.map(s => <option key={s}>{s}</option>)}
        </select>
      ) : type === 'textarea' ? (
        <textarea rows={3} value={editing[key] || ''} onChange={e => setEditing(p => ({ ...p, [key]: e.target.value }))} />
      ) : (
        <input type={type} value={editing[key] || ''} onChange={e => setEditing(p => ({ ...p, [key]: e.target.value }))} />
      )}
    </div>
  );

  return (
    <div>
      <h1>Reservations <span className="count">{reservations.length}</span></h1>
      {reservations.length === 0
        ? <div className="empty">No reservations yet.</div>
        : reservations.map(r => (
          <div key={r.id} className="admin-card">
            <div className="card-header">
              <strong>{r.fullName}</strong>
              <span className={`badge badge-${r.status}`}>{r.status}</span>
            </div>
            <div className="card-meta">
              <span>📧 {r.email}</span>
              <span>📞 {r.phone}</span>
              <span>🎯 {r.service}</span>
              {r.date && <span>📅 {r.date}</span>}
              {r.time && <span>🕐 {r.time}</span>}
            </div>
            {r.notes && <p className="card-notes">"{r.notes}"</p>}
            <div className="card-actions">
              {r.status === 'pending' && <>
                <button className="action-btn confirm" onClick={() => updateStatus(r.id, 'confirmed')}>✓ Confirm</button>
                <button className="action-btn cancel" onClick={() => updateStatus(r.id, 'cancelled')}>✕ Cancel</button>
              </>}
              <button className="action-btn edit" onClick={() => setEditing({ ...r })}>✎ Edit</button>
              <button className="action-btn delete" onClick={() => remove(r.id)}>🗑 Delete</button>
            </div>
          </div>
        ))
      }

      {editing && (
        <div className="modal-overlay" onClick={() => setEditing(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setEditing(null)}>✕</button>
            <h2>Edit Reservation</h2>
            <div className="edit-grid">
              {field('fullName', 'Full Name')}
              {field('email', 'Email', 'email')}
              {field('phone', 'Phone', 'tel')}
              {field('service', 'Service', 'select')}
              {field('date', 'Date', 'date')}
              {field('time', 'Time', 'time')}
              {field('notes', 'Notes', 'textarea')}
              <div className="edit-field">
                <label>Status</label>
                <select value={editing.status} onChange={e => setEditing(p => ({ ...p, status: e.target.value }))}>
                  <option>pending</option>
                  <option>confirmed</option>
                  <option>cancelled</option>
                </select>
              </div>
            </div>
            <button className="btn-primary" style={{ marginTop: '1rem', width: '100%' }} onClick={save}>Save Changes</button>
          </div>
        </div>
      )}
    </div>
  );
}
